// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__RiEse","content":"error_content__+gUdA","error_text":"error_error_text__tum1n","title":"error_title__2+1Ew"};